import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);
export default {
  init() {
    //gsap animaties:
    gsap.utils.toArray('.is-style-indrukwekkend-vakbladvroeg').forEach(function(elem) {
      // hide(elem); // assure that the element is hidden when scrolled into view, ?
      let figure= elem.querySelector('figure');
      let content = elem.querySelector('.wp-block-media-text__content');
      hide(figure); // assure that the element is hidden when scrolled into view
      hide(content); // assure that the element is hidden when scrolled into view
      ScrollTrigger.create({
        trigger: elem,
        start: 'top bottom-=100',
        once: true,
        onEnter: function() { animateFrom(elem) }, 
        //onEnterBack: function() { animateFrom(elem, -1) },
        //onLeave: function() { hide(figure), hide(content) }, // assure that the element is hidden when scrolled into view
        //onLeaveBack: function() { hide(figure), hide(content) }, // assure that the element is hidden when scrolled into view
      });
    });
  },
};

function animateFrom(elem, direction) {
  direction = direction | 1;
  var x = 0,
      y = direction * 100;
  if(elem.classList.contains('has-media-on-the-right')) {
    x = 100;
    y = 0;
  } else {
    x = -100;
    y = 0;
  }

  let figure= elem.querySelector('figure');
  gsap.fromTo(figure, {x: x, y: y, autoAlpha: 0}, {
    duration: 2.25, 
    x: 0,
    y: 0, 
    autoAlpha: 1, 
    ease: 'expo', 
    overwrite: 'auto',
  });

  let content = elem.querySelector('.wp-block-media-text__content');
  x = 0,
  y = direction * 100;
  gsap.fromTo(content, {x: x, y: y, autoAlpha: 0}, {
    duration: 2.25, 
    x: 0,
    y: 0, 
    autoAlpha: 1, 
    ease: 'expo', 
    overwrite: 'auto',
  });
}

function hide(elem) {
  gsap.set(elem, {autoAlpha: 0});
}
